import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { t } from 'i18next'
import { closeModal } from 'actions/app'
import { createMarker } from 'api/marker'
import * as c from 'common/c'
import ModalTool from 'components/modal/modal-tool'
import { TEST_IDS } from '../../../test-ids'
import type { AppState } from 'state/index.js'
import type { Coordinate } from 'ol/coordinate'

type Props = {
  coordinate: Coordinate
}

export default function CreateMarkerDialog({ coordinate }: Props) {
  const dispatch = useDispatch()
  const markerTypes = useSelector((state: AppState) => state.marker.markerTypes)

  const [markerTypeId, setMarkerTypeId] = useState('')
  const [note, setNote] = useState('')

  const handleClose = () => {
    dispatch(closeModal())
  }

  const handleApply = () => {
    dispatch(createMarker(markerTypeId, coordinate, note || undefined) as any)
    dispatch(closeModal())
  }

  const content = (
    <div data-testid={TEST_IDS.createMarkerDialog}>
      <FormControl fullWidth margin="normal">
        <InputLabel>{t('select_marker_type')}</InputLabel>
        <Select
          value={markerTypeId}
          label={t('select_marker_type')}
          onChange={(e) => setMarkerTypeId(e.target.value)}
          slotProps={{
            input: { 'data-testid': TEST_IDS.createMarkerTypeSelect } as any,
          }}
        >
          {markerTypes.map((mt) => (
            <MenuItem key={mt.id} value={mt.id}>
              {mt.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        fullWidth
        margin="normal"
        label={t('marker_note')}
        value={note}
        onChange={(e) => setNote(e.target.value)}
        multiline
        rows={3}
        slotProps={{
          htmlInput: { 'data-testid': TEST_IDS.createMarkerNoteInput },
        }}
      />
    </div>
  )

  return (
    <ModalTool
      header={t('create_marker')}
      content={content}
      onClose={handleClose}
      onApply={handleApply}
      disabled={!markerTypeId}
      applyTranslationKey="create_marker"
    />
  )
}
